__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "clip-factory";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@radix-ui/react-alert-dialog", "1.1.15", () => (() => (__webpack_require__(2610))), 1);
			register("@radix-ui/react-dialog", "1.1.15", () => (() => (__webpack_require__(5179))), 1);
			register("@radix-ui/react-label", "2.1.8", () => (() => (__webpack_require__(5131))), 1);
			register("@radix-ui/react-select", "2.2.6", () => (() => (__webpack_require__(7145))), 1);
			register("@radix-ui/react-slot", "1.2.3", () => (() => (__webpack_require__(9204))), 1);
			register("@radix-ui/react-slot", "1.2.3", () => (() => (__webpack_require__(5485))), 1);
			register("@radix-ui/react-slot", "1.2.3", () => (() => (__webpack_require__(4473))), 1);
			register("@radix-ui/react-slot", "1.2.3", () => (() => (__webpack_require__(6590))), 1);
			register("@radix-ui/react-slot", "1.2.3", () => (() => (__webpack_require__(3357))), 1);
			register("@radix-ui/react-slot", "1.2.3", () => (() => (__webpack_require__(8088))), 1);
			register("@radix-ui/react-slot", "1.2.4", () => (() => (__webpack_require__(6851))), 1);
			register("@radix-ui/react-tooltip", "1.2.8", () => (() => (__webpack_require__(8126))), 1);
			register("class-variance-authority", "0.7.1", () => (() => (__webpack_require__(917))), 1);
			register("clsx", "2.1.1", () => (() => (__webpack_require__(8387))), 1);
			register("lucide-react", "0.562.0", () => (() => (__webpack_require__(2485))), 1);
			register("react-dom", "19.2.3", () => (() => (__webpack_require__(7950))), 1);
			register("react-router-dom", "6.30.2", () => (() => (__webpack_require__(3245))), 1);
			register("react", "19.2.3", () => (() => (__webpack_require__(5043))), 1);
			register("socket.io-client", "4.8.3", () => (() => (__webpack_require__(2104))), 1);
			register("tailwind-merge", "3.4.0", () => (() => (__webpack_require__(9359))), 1);
			initExternal(2482);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};